import * as XLSX from "xlsx";
import moment from "moment";

const asDate = (value) => (value ? moment(value).format("DD/MM/YYYY") : "");

const yesNo = (value) => {
     if (value === true) return "Yes";
     if (value === false) return "No";
     return "";
};

// Every card, played or not, and every card missed for want of accreditation, one row each.
const CARD_COLUMNS = [
     ["Area", (row) => row.area || ""],
     ["Dealer Code", (row) => row.dealerCode || ""],
     ["Dealership", (row) => row.dealerName || ""],
     ["Name", (row) => row.name || ""],
     ["Email", (row) => row.email || ""],
     ["Account activated", (row) => yesNo(row.accountActivated)],
     ["Round", (row) => row.roundNumber ?? ""],
     ["Card issued", (row) => asDate(row.issuedOn)],
     ["Status", (row) => row.status || ""],
     ["Won (GBP)", (row) => row.valueGbp ?? ""],
     ["Points", (row) => row.points ?? ""],
     ["Played", (row) => asDate(row.playedOn)],
];

const DEALERSHIP_COLUMNS = [
     ["Area", (row) => row.area || ""],
     ["Dealer Code", (row) => row.dealerCode || ""],
     ["Dealership", (row) => row.dealerName || ""],
     ["Brake disc sales", (row) => row.brakeDiscSales ?? 0],
     ["Rounds unlocked", (row) => row.roundsUnlocked ?? 0],
     ["Cards issued", (row) => row.cardsIssued ?? 0],
     ["Cards played", (row) => row.cardsPlayed ?? 0],
     ["Funding generated (GBP)", (row) => row.fundingGbp ?? 0],
     ["Awarded (GBP)", (row) => row.awardedGbp ?? 0],
];

// Campaign wide whatever the filters, because the pockets are kept for the campaign.
const POT_ROWS = [
     ["Funding generated (GBP)", (pot) => pot?.fundingGbp ?? 0],
     ["Standard pot available (GBP)", (pot) => pot?.standardAvailableGbp ?? 0],
     ["Hero reserve (GBP)", (pot) => pot?.heroReserveGbp ?? 0],
     ["Committed to unplayed cards (GBP)", (pot) => pot?.committedGbp ?? 0],
     ["Awarded (GBP)", (pot) => pot?.awardedGbp ?? 0],
     ["Hero prize value (GBP)", (pot) => pot?.heroPrizeGbp ?? 0],
];

const toRows = (rows, columns) =>
     (rows || []).map((row) => columns.map(([, read]) => read(row)));

// Two sheets from one response: the cards, then the dealerships with the pot totals under them.
export const writeReportWorkbook = (reportExport) => {
     const cardsSheet = XLSX.utils.aoa_to_sheet([
          CARD_COLUMNS.map(([heading]) => heading),
          ...toRows(reportExport.cards, CARD_COLUMNS),
     ]);

     const summarySheet = XLSX.utils.aoa_to_sheet([
          DEALERSHIP_COLUMNS.map(([heading]) => heading),
          ...toRows(reportExport.dealerships, DEALERSHIP_COLUMNS),
          [],
          ["Campaign pot (all dealerships)"],
          ...POT_ROWS.map(([heading, read]) => [heading, read(reportExport.pot)]),
     ]);

     const workbook = XLSX.utils.book_new();

     XLSX.utils.book_append_sheet(workbook, cardsSheet, "Cards");
     XLSX.utils.book_append_sheet(workbook, summarySheet, "Summary");
     XLSX.writeFile(
          workbook,
          `optimum-friction-report-${moment().format("YYYY-MM-DD")}.xlsx`,
     );
};
